export const copyToClipboard = (str: string) => {
  navigator.clipboard.writeText(str)
}

export const getPadLink = (padName: string) => {
  return `${window.location.origin}/${padName}`
}
